import React from 'react';
import { useCart } from '../context/CartContext';

const ShippingMethodSelection = () => {
  const { shippingMethod, dispatch } = useCart();
  const shippingOptions = [
    { value: 'colissimo', label: 'Colissimo' },
    { value: 'chronopost', label: 'Chronopost' },
  ];

  const handleShippingChange = (event) => {
    dispatch({ type: 'SET_SHIPPING_METHOD', payload: event.target.value });
  };

  return (
    <div className="bg-white border border-slate-200 p-6 rounded-xl shadow-sm">
      <label htmlFor="shipping" className="block text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">
        Méthode de livraison
      </label>
      <select 
        id="shipping" 
        value={shippingMethod} 
        onChange={handleShippingChange} 
        className="w-full rounded-lg border border-slate-200 bg-slate-50 p-2.5 text-sm text-slate-800 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 focus:outline-none transition-all"
      >
        {shippingOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ShippingMethodSelection;